import { createFileRoute } from '@tanstack/react-router';
import { PurchasingReport } from '../../../features/reports/screens/PurchasingReport';

export interface PurchasingReportSearch {
  supplierId?: string;
}

/** Owned by G25. Report #6 — open/partial PO book + supplier spend. Accepts an
 * optional `?supplierId=` deep link from global search (a SUPPLIER match). */
export const Route = createFileRoute('/_authenticated/reports/purchasing')({
  validateSearch: (search: Record<string, unknown>): PurchasingReportSearch => ({
    supplierId: typeof search.supplierId === 'string' ? search.supplierId : undefined,
  }),
  component: PurchasingReportRoute,
});

function PurchasingReportRoute() {
  const { supplierId } = Route.useSearch();
  return <PurchasingReport initialSupplierId={supplierId} />;
}
